export default __webpack_public_path__ + "static/media/future-house_thumb.63688a19.png";